import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { gridPageRequest } from '../../../model/common/common.model';
import { vendorGridResponse } from '../../../model/masters.model';
import { VendorService } from '../../../services/vendor.service';
import { Table, TableRowSelectEvent } from 'primeng/table';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-vendor-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './vendor-lookup.component.html',
  styleUrl: './vendor-lookup.component.scss'
})
export class VendorLookupComponent implements OnInit {


  constructor(private Vendorservice: VendorService,public ref: DynamicDialogRef, private messageService: MessageService) { }

  searchKey: any;
  loader: boolean = false;
  vendorList: any[] = [];

  @ViewChild('dt1') dt1: Table | undefined;
  ngOnInit(): void {
    this.searchEffect();
    this.getVendor();
  }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  }

  result: vendorGridResponse = {
    vendors: [],
    totalRecords: 0
  }


  getVendor() {
    this.loader = true;
    this.Vendorservice.getVendorLookup(this.pageRequest).subscribe({ 
      next: (data: any) => {
        this.loader = false;
        this.vendorList = data.vendors;
      },
      error: (error: Error) => {
        this.loader = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: 'Error occurred while fetching contacts.'
        });
      }
    });
  }


  SelectOption(event: any) {
    if (event?.data) {
      this.ref.close(event?.data);
    } else {
      this.ref.close(event);
    }
  }

  load(event: any): void {
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + event.rows + 5;
    this.getVendor();
  }

  refreshData(): void {
    this.searchKey = '';
    if (this.dt1) {
      this.dt1.clear();
      this.dt1.first = 0;
    }
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 20;
    this.getVendor();
  }


  searchVendor(): void {
    const filterValue = this.searchKey?.trim();
    if (!filterValue) {
      this.getVendor();
      return;
    }

    this.loader = true;
    this.Vendorservice.autoSearchVendor(filterValue).subscribe({
      next: (data: any) => {
        this.loader = false;
        this.vendorList = data;
        if (this.dt1) {
          this.dt1.first = 0;
        }
      },
      error: (error: Error) => {
        this.loader = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Search Failed',
          detail: 'Error occurred while searching contacts.'
        });
      }
    });
  }

  
  placeholder: string = 'Search By ';
  private messages: string[] = [ 'Vendor Code', 'Vendor Name','City',	'State'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }

}
